<template>
  <section>
      <div class="v-align">
      <div class="inner">
        <div class="swpoll-lboard-head">
          <h5>Leaderboard</h5>
        </div>
        <div class="swpoll-lboard-body">
          <div class="tabs">
            <button class="tabs-tab" data-id="tab1" @click="setTab('topScorers')" :class="activeTab === 'topScorers' ? 'active' : ''">
              Top Scorers
            </button>
            <button class="tabs-tab" data-id="tab2" @click="setTab('allTime')" :class="activeTab === 'allTime' ? 'active' : ''">
              All-Time
            </button>
          </div>
          <div class="tab-content">
            <div class="tab-panel" id="tab1" :class="activeTab === 'topScorers' ? 'active' : ''">
              <transition-group appear name="option-list" tag="ul">
                <li
                  class="option-list swpoll-vote showanswer"
                  :class="[`item${index + 1}`, { self: ranking.self }]"
                  v-for="(ranking, index) in getLeaderboardList" :key="ranking.voterId"
                >
                  <div class="swbar">
                    <div class="swbar-bar" :style="{ width: `${ranking.points || 0}%` }"></div>
                  </div>
                  <p class="swperc">
                    <span class="swvalue">{{ranking.points || 0}}</span>
                  </p>
                  <div class="swimg">
                    <div class="v-align">
                      <div class="inner">{{ranking.rank || index + 1}}</div>
                    </div>
                  </div>
                  <div class="text">
                    <p>{{ranking.self ? 'You' : ranking.name}}</p>
                  </div>
                  <!--            <div class="you" v-if="ranking.self">You</div>-->
                </li>

                <li v-if="loaded && rank > 10" class="option-list swpoll-vote showanswer separated self"
                    :key="voterId">
                  <div class="swbar">
                    <div class="swbar-bar" :style="{ width: `${points || 0}%` }"></div>
                  </div>
                  <p class="swperc">
                    <span class="swvalue">{{Math.round(points) || 0}}</span>
                  </p>
                  <div class="swimg">
                    <div class="v-align">
                      <div class="inner">{{rank}}</div>
                    </div>
                  </div>
                  <div class="text">
                    <p>You</p>
                  </div>
                </li>
              </transition-group>
            </div>
            <div class="tab-panel" id="tab2" :class="activeTab === 'allTime' ? 'active' : ''">
              <transition-group appear name="option-list" tag="ul">
                <li
                  class="option-list swpoll-vote showanswer"
                  :class="[`item${index + 1}`, { self: ranking.self }]"
                  v-for="(ranking, index) in getLeaderboardList" :key="ranking.voterId"
                >
                  <div class="swbar">
                    <div class="swbar-bar" :style="{ width: `${ranking.points || 0}%` }"></div>
                  </div>
                  <p class="swperc">
                    <span class="swvalue">{{ranking.points || 0}}</span>
                  </p>
                  <div class="swimg">
                    <div class="v-align">
                      <div class="inner">{{ranking.rank || index + 1}}</div>
                    </div>
                  </div>
                  <div class="text">
                    <p>{{ranking.self ? 'You' : ranking.name}}</p>
                  </div>
                  <!--            <div class="you" v-if="ranking.self">You</div>-->
                </li>

                <li v-if="loaded && rank > 10" class="option-list swpoll-vote showanswer separated self"
                    :key="voterId">
                  <div class="swbar">
                    <div class="swbar-bar" :style="{ width: `${points || 0}%` }"></div>
                  </div>
                  <p class="swperc">
                    <span class="swvalue">{{Math.round(points) || 0}}</span>
                  </p>
                  <div class="swimg">
                    <div class="v-align">
                      <div class="inner">{{rank}}</div>
                    </div>
                  </div>
                  <div class="text">
                    <p>You</p>
                  </div>
                </li>
              </transition-group>
            </div>
          </div>

        </div>
        <div class="swpoll-lboard-foot">
<!--          <a :href="getRetakeQuizUrl()"-->
<!--            class="btn btn-small btn-outline">-->
<!--            Retake Quiz-->
<!--          </a>-->
          <button class="btn btn-small btn-outline btn-showsummary"
                  @click="switchView('summary')"
          >
            Summary
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  mapActions,
  mapState,
  mapGetters
} from 'vuex';

export default {
  name: 'Leaderboard',
  data() {
    return {
      activeTab: 'topScorers',
      loaded: false,
      inMainList: false,
      activeList: [],
      topScoresList: [],
      allTimeList: [],
    }
  },
  computed: {
    getLeaderboardList() {
      const rankings = this.activeList;
      if (!rankings.length)  {
        return [];
      }
      if (window.innerWidth <= 768) {
        rankings.splice(4, 2);
      }
      const voter = rankings.find(({ voterId }) => voterId === this.voterId);
      if (voter) {
        voter.self = true;
        return this.roundPoints(rankings);
      }

      rankings.splice(rankings.length-1, 1);
      rankings.push({
        voterId: this.voterId,
        points: this.points,
        name: this.name,
        rank: this.rank,
        self: true
      });
      return this.roundPoints(rankings);
    },
    ...mapState('poll', [
      'group',
      'accountName',
      'pollGroupId'
    ]),
    ...mapState('voter', [
      'points',
      'rank',
      'voterId',
      'name'
    ]),
    ...mapGetters('poll', [
      'playLink',
    ]),
    ...mapState('pollGroup', {
      pollGroupIdFromPollGroupStore: state => state.pollGroupId
    })
  },
  watch: {
    getLeaderboardList() {
      if (this.activeList.find(({ self }) => self)) {
        this.inMainList = true;
      }
    },
    activeTab() {
      this.activeList = this.activeTab === 'topScorers' ? this.topScoresList : this.allTimeList;
    }
  },
  methods: {
    roundPoints(rankings) {
      return rankings.map((ranking) => {
        return {
          ...ranking,
          points: Math.round(ranking.points)
        }
      });
    },
    ...mapActions('voter', [
      'getLeaderboard',
      'getLeaderBoardByPollGroup',
      'getVoterData',
      'getVoterRank',
      'switchView'
    ]),
    setTab(tabName) {
      this.activeTab = tabName;
    },
    getRetakeQuizUrl() {
      return `${this.playLink}pollgroup/${this.pollGroupId}`;
    }
  },
  async mounted() {
    try {
      const pollGroupId = this.pollGroupId || this.pollGroupIdFromPollGroupStore;
      [this.allTimeList, this.topScoresList] = await Promise.all([
        this.getLeaderboard({ group: this.group, limit: 10 }),
        this.getLeaderBoardByPollGroup({ pollGroupId })
      ]);

      this.activeList = this.activeTab === 'topScorers' ? this.topScoresList : this.allTimeList; 
      await this.getVoterData(this.accountName);
      !this.inMainList && await this.getVoterRank();
      this.loaded = true;
    } catch (e) {
      console.error(e);
      this.activeList = [];
    }
  }
}
</script>

<style scoped lang="scss">
section {
  position: static;
  top: 40px;
  left: 40px;
  right: 40px;
  bottom: 40px;
  margin: 0 auto;
  min-width: 140px;
  z-index: 100;
  text-align: center;
  padding-bottom: 30px;

  > .v-align {
    display: table;
    margin: 0 auto;
    height: 100%;

    > .inner {
      display: table-cell;
    }
  }
}

ul {
  padding: 0;
  list-style: none;
  display: inline-block;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  row-gap: 4px;
  -webkit-perspective: 1000px;
  perspective: 1000px;
  margin: 0;
}

h2 {
  margin: 0 18px;
  font-size: var(--question-fontsize);
  color: var(--question-color);
  transition: all 500ms cubic-bezier(0.230, 1.000, 0.320, 1.000);
  text-align: left;
}

.swpoll-vote {
  display: flex;
  align-items: center;
  position: relative;
  color: var(--answer-color);
  box-shadow: inset 0 0 0 var(--answer-borderwidth) var(--answer-bordercolor);
  background-color: var(--answer-bg);
  transition: transform 900ms cubic-bezier(0.230, 1.000, 0.320, 1.000),
              box-shadow 350ms cubic-bezier(0.230, 1.000, 0.320, 1.000);
  border-radius: var(--answer-radius);
  padding: 5px;
  text-decoration: none !important;
  margin-right: 1px;
  transition: .3s ease-out;
  transform: scale(1) translate3d(0,0,0);
  opacity: 1;
  backdrop-filter: blur(4px);
  text-align: left;
  column-gap: 8px;

  // @media screen and (min-aspect-ratio: "2.5/1") {
  //   float: left;
  //   width: calc(33.333% - 10px);
  //   margin-left: 5px;
  //   margin-right: 5px;
  // }

  &.self {
      background-color: rgba(255, 255, 255, 0.8);
      color: var(--answer-active);
      margin-top: 16px;
      .swimg {
        background-color: rgba(0, 0, 0, 0.6);
      }
      .inner {
        color: #ffffff;
      }
    }

  p {
    margin: 0;
  }

  .text {
    padding-right: 50px;
    flex: 1 1 auto;
    position: relative;
    z-index: 1;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    text-align: left;
    font-size: 1.1rem;
    font-weight: 700;
    min-width: 1px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    p {
      font-size: var(--answer-fontsize);

      span {
        display: inline;

        &.animateLetter {
          animation: letterPop ease-in-out .35s;
          animation-iteration-count: 1;
          animation-fill-mode: forwards;
          position: relative;
        }
      }
    }
  }

  .you {
    padding-right: 15px;
    flex: 1 1 auto;
    position: relative;
    z-index: 1;

    p {
      font-size: var(--answer-fontsize);

      span {
        display: inline;

        &.animateLetter {
          animation: letterPop ease-in-out .35s;
          animation-iteration-count: 1;
          animation-fill-mode: forwards;
          position: relative;
        }
      }
    }
  }

  .swbar {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    border-radius: var(--answer-radius);
    overflow: hidden;
    transform: translate3d(0, 0, 0);
    transition: all 750ms cubic-bezier(0.22, 1, 0.36, 1);

    .swbar-bar {
      background: var(--result-bar-bg);
      position: absolute;
      left: 0;
      top: 0;
      width: 0;
      transition: all 750ms cubic-bezier(0.22, 1, 0.36, 1);
      height: 100%;
      opacity: 0;
      visibility: hidden;
    }
  }

  .swperc {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    opacity: 1;
    transition: all 750ms cubic-bezier(0.22, 1, 0.36, 1);
    z-index: 1;
  }

  .swimg {
    width: 36px;
    height: 36px;
    border-radius: var(--answer-img-radius);
    overflow: hidden;
    flex: 0 0 auto;
    transition: all 2500ms cubic-bezier(0.22, 1, 0.36, 1);
    transform: scale(1);
    text-align: center;
    background: rgba(255,255,255,0.1);

    > .v-align {
      display: table;
      margin: 0 auto;
      height: 100%;

      > .inner {
        display: table-cell;
        vertical-align: middle;
      }
    }
  }
}

.style-square {

  .swpoll-vote {
    border-radius: 4px;

    .swbar {
      border-radius: 4px;
    }
  }
}

.option-list-enter-active {
  transition: all 750ms cubic-bezier(0.22, 1, 0.36, 1);
}

.option-list-enter {
  opacity: 0;
  transform: scale(0.8);
}

.option-list-enter-to {
  opacity: 1;
  transform: scale(1);
}

@for $i from 0 through 10 {
  .option-list-enter-active:nth-child(#{$i}) {
    transition-delay: $i * 100ms + 600ms;
  }

  .button-#{$i}-enter-active {
    transition: all 750ms cubic-bezier(0.22, 1, 0.36, 1);
  }

  .button-#{$i}-enter {
    opacity: 0;
    transform: scale(0.8);
  }

  .button-#{$i}-enter-to {
    opacity: 1;
    transform: scale(1);
  }

  .button-#{$i}-enter-active {
    transition-delay: ($i+1) * 100ms + 600ms;
  }
}

.fontLoaded {

  .text {
    opacity: 1;
  }

  .swpoll-vote {

    &.disabled {
      opacity: 0.5;
    }
  }
}

.isHorizontal {
  section {
    margin: 12px auto 0;
    .swimg {
      background: #A8DBFF;
      color: #102B50;
      font-weight: bold;
      font-size: 20px;
    }
    .swperc {
      color: #A8DBFF;
      font-size: 20px;
      font-weight: bold;
    }
  }

  ul {
    display: flex;
    flex-wrap: wrap;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }

  .swpoll-vote {
    margin-right: 8px;
    margin-bottom: 8px;
    padding: var(--answer-hor-padding-ver) var(--answer-hor-padding-hor);
    min-height: var(--answer-hor-min-height);
    font-size: var(--answer-hor-fontsize);

    .text {
      p {
        font-size: var(--answer-hor-fontsize);
      }
    }
  }
}

.style-bbl,
.style-veev {

  section {
    top: 10px;

    .v-align {
      display: flex;
      flex-direction: column;
    }

    @media screen and (max-width: 768px) {
      margin-left: -20px;
      width: calc(100% - 40px);
    }

    ul {
      justify-content: initial;

      @media screen and (max-width: 768px) {
        display: block;
      }

      .swpoll-vote {
        position: relative;
        width: calc(33.3333% - 10px);
        margin-left: 0;
        margin-right: 10px;

        @media screen and (max-width: 768px) {
          width: 100%;
          margin-right: 17px;
          padding-right: 0;
        }

        .you {
          position: absolute;
          top: -4px;
          right: -4px;
          height: 14px;
          line-height: 14px;
          font-size: 10px;
          border-radius: 7px;
          padding: 0 6px;
          background: #fff;
          color: #000;
        }

        .text {
          overflow: hidden;
          padding-right: 90px;

          p {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        .swimg {
          height: 23px;
          min-width: 23px;
          border-radius: 11.5px;

          .inner {
            font-size: 15px;

            &.sm {
              font-size: 13px;
            }
          }
        }



        &:nth-child(5),
        &:nth-child(6) {
          @media screen and (max-width: 768px) {
            display: none;
          }
        }
      }
    }
  }
}

.style-bbl section ul {
  &:nth-child(1) {
    background: rgba(255,215,0,0.9);
    .swimg {
      background: #fff;
    }
    .text {
      p {
        color: #fff;
      }
    }
    .swperc {
      .swvalue {
        color: #fff;
      }
    }
  }

}

.style-veev section ul .swpoll-vote .swimg {
  height: 30px;
  width: 30px;
  border-radius: 50%;
  margin-top: -6px;
  margin-bottom: -6px;
  margin-left: -14px;
}

.style-veev section ul .swpoll-vote .swimg {
  background: #a28452 !important;
}
.style-veev.isHorizontal section {
  .swimg,
  .swperc {
    color: white;
  }
}
.style-veev section ul .swpoll-vote .text {
  padding-right: 50px;
}

.tabs {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  margin-bottom: 8px;
}

.tabs-tab {
  border: none;
  background-color: transparent;
  color: var(--answer-color);
  font-weight: 700;
  opacity: .5;
  padding: 8px 16px;
  border-radius: 16px;
  line-height: 1em;
  -webkit-transition: .2s;
  transition: .2s;
}

.tabs-tab.active {
  background-color: rgba(255, 255, 255, 0.2);
  opacity: 1 !important;
  cursor: default !important;
}

.tabs-tab:hover {
  opacity: .65;
  cursor: pointer;
}

.tab-panel {
  display: none;
}

.tab-panel.active {
  display: block;
}

h5 {
  font-size: 1.4rem;
  margin: 0;
}

.swpoll-lboard {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: var(--background-color);
  z-index: 2;
  text-align: center;
  padding: 30px;
  opacity: 0;
  visibility: hidden;
  transition: opacity .6s, visibility .6s;
  &-head, &-body, &-foot {
    transition: .6s cubic-bezier(0.165, 0.840, 0.440, 1.000);
    transform: translateY(70px);
    opacity: 0;
  }
  &-head {
    flex: 0 0 auto;
  }
  &-body {
    padding: 32px 0;
    flex: 1 1 auto;
    width: 100%;
  }
  @media only screen and (min-width: 600px) {
    .swpoll-lboard-body {
      width: 100%;
      max-width: 350px;
      -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
      flex: 0 0 auto;
    }
  }
  &-foot {
    flex: 0 0 auto;
    .btn {
      min-width: 130px;
    }
  }
}

.swpoll-lboard {
  opacity: 1;
  visibility: visible;
  &-head, &-body, &-foot {
    transform: translateY(0);
    opacity: 1;
  }
}

.btn {
  display: inline-block;
  line-height: 1em;
  padding: 16px 20px;
  text-align: center;
  border: none;
  border-radius: var(--button-radius);
  font-family: var(--font-body);
  font-size: 1rem;
  font-weight: 700;
  text-decoration: none;
  &:hover {
    cursor: pointer;
  }
  &:focus {
    outline: none;
  }
  &.disabled {
    box-shadow: inset 0 0 0 1px rgba(255,255,255,.2);
    pointer-events: none;
    background-color: transparent;
    color: rgba(255,255,255,.5);
  }
}
.btn-outline {
  background-color: transparent;
  color: var(--button-color);
  -webkit-box-shadow: 0 0 0 2px inset var(--button-color);
  box-shadow: 0 0 0 2px inset var(--button-color);
  &:hover {
    box-shadow: 0 0 0 3px inset var(--button-color);
  }
}
.btn-small {
  padding-top: 10px;
  padding-bottom: 10px;
}
.btn-showsummary {
  margin-left: 5px;
}
</style>
